import { createRouter, createWebHistory } from 'vue-router'
import ClubPage from '../views/HomeView.vue'

import ClubGestion from '../views/Club/ClubGestion.vue'
import ClubForm from '../components/Club/alta-club.vue';
import ListarClubes from '../components/Club/listar-clubes.vue';
import VerClub from '../components/Club/ver-club.vue';
import GestionPuntosAbastecimiento from '@/components/Club/GestionPuntosAbastecimiento.vue';
import AltaPuntoAbastecimiento from '@/components/Club/AltaPuntoAbastecimiento.vue';
import ConfigurarPuntos from '@/components/Club/ConfigurarPuntos.vue';

import GestionUsuariosClub from '@/components/Configuracion/Usuarios/GestionUsuariosParaClub.vue';

import listarSalasDeCultivoVue from '../components/salaDeCultivo/listar-salasDeCultivo.vue';
import altaSalaDeCultivoVue from '../components/salaDeCultivo/alta-salaDeCultivo.vue';

import listarMesasDeCultivoVue from '../components/mesaDeCultivo/listar-mesasDeCultivo.vue';
import altaMesaDeCultivoVue from '../components/mesaDeCultivo/alta-mesaDeCultivo.vue';

import altaGeneticaVue from '../components/Genetica/alta-genetica.vue';
import listarGeneticas from '@/components/Genetica/listar-geneticas.vue';

import ProyectoGestion from '../views/Proyecto/ProyectoGestion.vue'
import ProyectoForm from '../components/Proyecto/alta-proyecto.vue';
import ListarProyectos from '../components/Proyecto/listar-proyectos.vue';
import AdministrarProyecto from '@/components/Proyecto/AdministrarProyecto.vue';
import salaPlantaGestion from '@/components/SalaPlanta/salaPlantaGestion.vue';
import salaGestion from '@/views/SalaPlanta/SalasGestion.vue';
import listarSalaPlanta from '@/components/SalaPlanta/listarSalaPlanta.vue';


import altaEventoProyecto from '../components/Evento/alta-eventoProyecto.vue'
import verEventoProyecto from '../components/Evento/ver-evento.vue'


import altaLote from '@/components/Lote/alta-lote.vue';
import verLote from '@/components/Lote/ver-lote.vue';

import altaPlantaLoteVue from '@/components/Planta/alta-plantaLote.vue';
import listarPlantaLote from '@/components/Planta/listar-plantasLote.vue';

import AltaTarea from '@/components/Tarea/altaTarea/alta-tarea.vue';

import ListarTareas from '@/components/Tarea/listarTareas/listar-tareas.vue';

import InventarioProvedores from '../views/Inventario/InventarioProveedores.vue';
import listarItemInventario from '@/components/Inventario/listar-ItemInventario.vue';
import altaProveedor from '@/components/Inventario/alta-proveedor.vue';
import altaInventarioItem from '@/components/Inventario/alta-InventarioItem.vue';
import altaOrdenDeCompra from '@/components/Inventario/alta-ordenDeCompra.vue';
import listarOrdenesDeCompra from '@/components/Inventario/listar-ordenesDeCompra.vue';

import cumplimientoGestion from '../views/Cumplimiento/CumplimientoGestion.vue'
import altaCumplimiento from '@/components/Cumplimiento/alta-editar-grupo.vue';
import ListarCumplimientos from '@/components/Cumplimiento/listar-cumplimientos.vue';

import planCultivoGestion from '../views/PlanCultivo/PlanCultivoGestion.vue'
import altaPlanCultivo from '@/components/PlanCultivo/crearPlan/alta-planCultivo.vue';
import listarPlanesCultivo from '@/components/PlanCultivo/listar-planesCultivo.vue';

import UserLogin from '../views/Auth/UserLogin.vue';
import UserRegister from '../views/Auth/UserRegister.vue';
import EditarPerfil from '../views/Auth/EditarPerfil.vue';
import GestionSuscripcion from '@/components/Configuracion/Usuarios/gestionSuscripciones/GestionSuscripcion.vue';

import ConfiguracionGestion from '@/views/Configuracion/ConfiguracionGestion.vue';
import GestionVariablesTareas from '@/components/Configuracion/GestionVariablesTareas/GestionVariablesTareas.vue';
import GestionUsuarios from '@/components/Configuracion/Usuarios/GestionUsuarios.vue';
import GestionarRolesYPermisos from '@/components/Configuracion/Usuarios/gestionRolesYPermisos/GestionarRolesYPermisos.vue';
import MonedaConfiguracion from '@/components/Configuracion/Moneda/MonedaConfiguracion.vue';

import GestionUbicaciones from '@/components/Configuracion/Club/GestionUbicaciones.vue';
import AltaUbicacion from '@/components/Configuracion/Club/AltaUbicacion.vue';

import proyectoEstadistica from '@/components/Estadisticas/proyectoEstadistica.vue';

import GestionarMateriaPrima from '@/views/MateriaPrima/GestionarMateriaPrima.vue';
import GestionarProductoFinal from '@/views/ProductoFinal/GestionarProductoFinal.vue';
import GestionarProductoFinalEnvasado from '@/views/ProductoFinal/GestionarProductoFinalEnvasado.vue';

import PersonalGestion from '@/views/Personal/PersonalGestion.vue';

import Cosechar from '@/components/Cosechar/Cosechar.vue';
import EventoPlantasView from '@/views/PlantaEvento/EventoPlantasView.vue';
import ListarPlantaEvento from '@/components/PlantaEvento/listarPlantaEvento.vue';
import LibretaTareas from '@/views/LibretaTareas/LibretaTareas.vue';

import TrazabilidadBuscador from '@/components/Trazabilidad/TrazabilidadBuscador.vue';
import GestionarExport from '@/views/Exportar/GestionarExport.vue';

import SolicitudUsoAdmin from '@/components/SolicitudUso/SolicitudUsoAdmin.vue';

import BienvenidaPublica from '@/views/BienvenidaPublica.vue'

import FlujoProduccion from '@/views/FlujoProduccion/FlujoProduccion.vue';
import CultivosWrapper from '@/views/Cultivos/CultivosWrapper.vue';

import MercadoPagoView from '@/views/MercadoPago/MercadoPagoView.vue';
import RenovarSuscripcion from '@/components/MercadoPago/RenovarSuscripcion.vue';
import PagoExitoso from '@/components/MercadoPago/PagoExitoso.vue';
import PagoFallido from '@/components/MercadoPago/PagoFallido.vue';
import PagoPendiente from '@/components/MercadoPago/PagoPendiente.vue';

import ManualDeUsuario from '@/views/ManualDeUsuario/ManualDeUsuario.vue';

import UsuariosMedicinales from '@/views/UsuariosMedicinales/UsuariosMedicinalesView.vue';

import AnalisisDashboard from '@/views/Analisis/AnalisisDashboard.vue';

const routes = [
  {
    path: '/',
    name: 'Inicio',
    component: ManualDeUsuario,
    meta: { requiresAuth: true}
  },
  {
    path: '/bienvenida',
    name: 'BienvenidaPublica',
    component: BienvenidaPublica,
    meta: { requiresAuth: false }
  },
  
  {
    path: '/manual-de-usuario',
    name: 'ManualDeUsuario',
    component: ManualDeUsuario,
    meta: { breadcrumb: 'Manual de Usuario' }
  },
  { path: '/login', name: 'Login', component: UserLogin },
  { path: '/register', name: 'Register', component: UserRegister },
  {
    path: '/configuracion', name: 'Configuracion', component: ConfiguracionGestion,
    meta: { breadcrumb: 'Configuración', requiresAuth: true },
    children: [
      {
        path: '/configuracion/variables-tareas',
        name: 'GestionVariablesTareas',
        component: GestionVariablesTareas,
        meta: { breadcrumb: 'Variables de Tareas' }
      },
      {
        path: '/configuracion/moneda',
        name: 'MonedaConfiguracion',
        component: MonedaConfiguracion,
        meta: { breadcrumb: 'Moneda' }
      },
      {
        path: '/configuracion/usuarios',
        name: 'GestionUsuarios',
        component: GestionUsuarios,
        meta: { breadcrumb: 'Usuarios' }
      },
      {
        path: '/configuracion/roles-permisos',
        name: 'GestionarRolesYPermisos',
        component: GestionarRolesYPermisos,
        meta: { breadcrumb: 'Roles y Permisos' }
      },
      {
        path: '/configuracion/editar-perfil',
        name: 'EditarPerfil',
        component: EditarPerfil
      },
      {
        path: '/configuracion/ubicaciones',
        name: 'GestionUbicaciones',
        component: GestionUbicaciones,
        meta: { breadcrumb: 'Ubicaciones' },
      },
      {
        path: '/configuracion/ubicaciones/alta',
        name: 'AltaUbicacion',
        component: AltaUbicacion,
        meta: { breadcrumb: 'Alta Ubicación' }
      },
      {
        path: '/configuracion/ubicaciones/editar/:id',
        name: 'EditarUbicacion',
        component: AltaUbicacion,
        props: true,
        meta: { breadcrumb: 'Editar Ubicación' }
      },
      {
        path: '/configuracion/suscripciones',
        name: 'GestionSuscripcion',
        component: GestionSuscripcion,
        meta: { breadcrumb: 'Suscripción' }
      },
      {
        path: '/configuracion/solicitudes-servicio',
        name: 'SolicitudUsoAdmin',
        component: SolicitudUsoAdmin,
        meta: { breadcrumb: 'Solicitudes de Uso' }
      },
      {
        path: '/configuracion/renovar-suscripcion',
        name: 'RenovarSuscripcion',
        component: RenovarSuscripcion,
        meta: { breadcrumb: 'Renovar Suscripción' }
      },
      {
        path: '/configuracion/gestion-usuarios-club',
        name: 'GestionUsuariosClub',
        component: GestionUsuariosClub,
        meta: { breadcrumb: 'Gestión de Usuarios del Club', requiresAuth: true }
      }

    ]
  },
  {
    path: '/',
    name: 'home',
    component: ClubPage,
    meta: { breadcrumb: 'Inicio', requiresAuth: true }
  },
  {
    path: '/club',
    name: 'club',
    component: ClubGestion,
    meta: { breadcrumb: 'Gestión de Club', requiresAuth: true }
  },
  {
    path: '/club/alta',
    name: 'clubForm',
    component: ClubForm,
    meta: { breadcrumb: 'Nuevo Club', requiresAuth: true }
  },
  {
    path: '/club/listar',
    name: 'listarClubes',
    component: ListarClubes,
    meta: { breadcrumb: 'Listado de Clubes', requiresAuth: true }
  },
  {
    path: '/club/:club_id',
    name: 'verClub',
    component: VerClub,
    props: {
      club_id: Number
    },
    meta: { breadcrumb: 'Ver Club', requiresAuth: true },
    children: [
      {
        path: 'salas',
        name: 'listarSalasDeCultivo',
        component: listarSalasDeCultivoVue,
        props: {
          club_id: Number
        },
        meta: { breadcrumb: 'Salas de Cultivo', requiresAuth: true },
        children: [
          {
            path: 'alta',
            name: 'altaSalaDeCultivo',
            component: altaSalaDeCultivoVue,
            props: {
              club_id: Number
            },
            meta: { breadcrumb: 'Nueva Sala de Cultivo', requiresAuth: true }
          },
        ]
      },

      {
        path: 'configurar-puntos',
        name: 'configurarPuntos',
        component: ConfigurarPuntos,
        props: {
          club_id: Number
        },
        meta: { breadcrumb: 'Configurar Puntos' },
        children: [
          {
            path: 'alta',
            name: 'altaPuntoAbastecimiento',
            component: AltaPuntoAbastecimiento,
            props: {
              club_id: Number
            },
            meta: { breadcrumb: 'Alta Punto de Abastecimiento' }
          },
          {
            path: 'listar',
            name: 'GestionPuntosAbastecimiento',
            component: GestionPuntosAbastecimiento,
            props: {
              club_id: Number
            },
            meta: { breadcrumb: 'Gestión de Puntos de Abastecimiento' }

          },
        ]
      },
    ],
  },

  {
    path: '/listarMesasDeCultivo',
    name: 'listarMesasDeCultivo',
    component: listarMesasDeCultivoVue,
    props: true,
    meta: { breadcrumb: 'Mesas de Cultivo', requiresAuth: true }
  },
  {
    path: '/altaMesaDeCultivo/:club_id/:salaDeCultivoId',
    name: 'altaMesaDeCultivo',
    component: altaMesaDeCultivoVue,
    props: true,
    meta: { breadcrumb: 'Nueva Mesa de Cultivo', requiresAuth: true }
  },
  {
    path: '/altaGenetica/:club_id',
    name: 'altaGenetica',
    component: altaGeneticaVue,
    props: true,
    meta: { breadcrumb: 'Alta Genética', requiresAuth: true }
  },
  {
    path: '/geneticas',
    name: 'listarGeneticas',
    component: listarGeneticas,
    meta: { breadcrumb: 'Geneticas', requiresAuth: true }
  },
  {
    path: '/proyecto',
    name: 'proyecto',
    component: ProyectoGestion,
    meta: { breadcrumb: 'Proyectos', requiresAuth: true },
    children: [
      {
        path: '/proyecto/:proyecto_id/lote/alta',
        name: 'altaLoteProyecto',
        component: altaLote,
        props: route => ({
          proyecto_id: Number(route.params.proyecto_id),
        }),
        meta: { breadcrumb: 'Alta Lote' }
      },
      {
        path: '/proyecto/:proyecto_id/lote/:lote_id/:club_id',
        name: 'verLoteProyecto',
        component: verLote,
        props: route => ({
          proyecto_id: Number(route.params.proyecto_id),
          lote_id: Number(route.params.lote_id),
          club_id: Number(route.params.club_id),
        }),
        meta: { breadcrumb: 'Ver Lote' },
        children: [
          {
            path: '/proyecto/:proyecto_id/lote/:lote_id/planta/alta/:club_id',
            name: 'altaPlantaLote',
            component: altaPlantaLoteVue,
            props: route => ({
              proyecto_id: Number(route.params.proyecto_id),
              lote_id: Number(route.params.lote_id),
              club_id: Number(route.params.club_id),
            }),
            meta: { breadcrumb: 'Alta Planta' }
          },
          {
            path: '/proyecto/:proyecto_id/lote/:lote_id/planta/listar/:club_id',
            name: 'listarPlantaLote',
            component: listarPlantaLote,
            props: route => ({
              proyecto_id: Number(route.params.proyecto_id),
              lote_id: Number(route.params.lote_id),
              lote_bloqueado: Boolean(route.params.lote_bloqueado),
              club_id: Number(route.params.club_id),
            }),
            meta: { breadcrumb: 'Listar Plantas' }
          }
        ]
      },
      {
        path: '/proyecto/:proyecto_id/evento/:proyecto_evento_id',
        name: 'verEventoProyecto',
        component: verEventoProyecto,
        props: route => ({
          proyecto_id: Number(route.params.proyecto_id),
          proyecto_evento_id: Number(route.params.proyecto_evento_id),
        }),
        meta: { breadcrumb: 'Ver Evento' },
        children: [
          {
            path: 'alta-tarea',
            name: 'AltaTarea',
            component: AltaTarea,
            props: route => ({
              proyecto_id: Number(route.params.proyecto_id),
              proyecto_evento_id: Number(route.params.proyecto_evento_id),
            }),
            meta: { breadcrumb: 'Alta Tarea' }
          },
          {
            path: 'listar-tareas',
            name: 'ListarTareas',
            component: ListarTareas,
            props: route => ({
              proyecto_id: Number(route.params.proyecto_id),
              proyecto_evento_id: Number(route.params.proyecto_evento_id),
            }),
            meta: { breadcrumb: 'Listar Tareas' }
          },
          {
            path: 'cosechar',
            name: 'Cosechar',
            component: Cosechar,
            props: route => ({
              proyecto_id: Number(route.params.proyecto_id),
              proyecto_evento_id: Number(route.params.proyecto_evento_id),
              productoEnEdicion: route.params.productoEnEdicion,
            }),
            meta: { breadcrumb: 'Cosechar' }
          },
          {
            path: 'evento-plantas',
            name: 'EventoPlantasView',
            component: EventoPlantasView,
            props: route => ({
              proyecto_id: Number(route.params.proyecto_id),
              proyecto_evento_id: Number(route.params.proyecto_evento_id),
            }),
            meta: { breadcrumb: 'Evento Plantas' },
            children: [
              {
                path: 'listarPlantaEvento',
                name: 'ListarPlantaEvento',
                component: ListarPlantaEvento,
                props: route => ({
                  proyecto_id: Number(route.params.proyecto_id),
                  proyecto_evento_id: Number(route.params.proyecto_evento_id),
                }),
                meta: { breadcrumb: 'Listar Plantas' }
              }
            ]
          }


        ]
      },
      {
        path: '/proyecto/:proyecto_id/administrar',
        name: 'administrarProyecto',
        component: AdministrarProyecto,
        props: route => ({
          proyecto_id: Number(route.params.proyecto_id),
        }),
        meta: { breadcrumb: 'Administrar Proyecto' }
      },
      {
        path: '/proyecto/:proyecto_id/sala-gestion',
        name: 'salaGestion',
        component: salaGestion,
        props: route => ({
          proyecto_id: Number(route.params.proyecto_id),
        }),
        meta: { breadcrumb: 'Gestion de Salas' },
        children: [
          {
            path: '/proyecto/:proyecto_id/sala-gestion/sala-planta-gestion',
            name: 'salaPlantaGestion',
            component: salaPlantaGestion,
            props: route => ({
              proyecto_id: Number(route.params.proyecto_id),
            }),
            meta: { breadcrumb: 'Gestion de Salas' },
          },
          {
            path: '/proyecto/:proyecto_id/sala-gestion/listar-sala-planta',
            name: 'listarSalaPlanta',
            component: listarSalaPlanta,
            props: route => ({
              proyecto_id: Number(route.params.proyecto_id),
            }),
            meta: { breadcrumb: 'Listar Sala-Planta' },
          }
        ]
      }


    ]
  },
  {
    path: '/proyecto/:proyecto_id/alta-evento',
    name: 'altaEventoProyecto',
    component: altaEventoProyecto,
    props: route => ({
      proyecto_id: Number(route.params.proyecto_id),
    }),
    meta: { breadcrumb: 'Alta Evento', requiresAuth: true }
  },
  {
    path: '/proyecto/alta',
    name: 'proyectoForm',
    component: ProyectoForm,
    meta: { breadcrumb: 'Nuevo Proyecto', requiresAuth: true }
  },
  {
    path: '/proyecto/listar',
    name: 'listarProyectos',
    component: ListarProyectos,
    meta: { breadcrumb: 'Listar Proyectos', requiresAuth: true }
  },
  {
    path: '/inventario_proveedores',
    name: 'inventarioProveedores',
    component: InventarioProvedores,
    meta: { breadcrumb: 'Proveedores de Inventario', requiresAuth: true },
    children: [
      {
        path: '/inventario_proveedores/:proveedor_id',
        name: 'listarItemInventario',
        component: listarItemInventario,
        props: route => ({
          proveedor_id: Number(route.params.proveedor_id),
        }),
        meta: { breadcrumb: 'Items de Inventario' }
      },
      {
        path: '/inventario_proveedores/alta',
        name: 'altaProveedor',
        component: altaProveedor,
        meta: { breadcrumb: 'Alta Proveedor' }
      },
      {
        path: '/inventario_proveedores/:proveedor_id/alta-inventario-item',
        name: 'altaInventarioItem',
        component: altaInventarioItem,
        props: true,
        meta: { breadcrumb: 'Alta Ítem de Inventario' }
      },
      {
        path: '/inventario_proveedores/:proveedor_id/alta-orden-de-compra',
        name: 'altaOrdenDeCompra',
        component: altaOrdenDeCompra,
        props: true,
        meta: { breadcrumb: 'Alta Orden de Compra' }
      },
      {
        path: '/inventario_proveedores/:proveedor_id/listar-ordenes-de-compra',
        name: 'listarOrdenesDeCompra',
        component: listarOrdenesDeCompra,
        props: true,
        meta: { breadcrumb: 'Listar Órdenes de Compra' }
      }
    ]
  },
  {
    path: '/gestionar_materia_prima',
    name: 'GestionarMateriaPrima',
    component: GestionarMateriaPrima,
    meta: { breadcrumb: 'Gestionar Materia Prima', requiresAuth: true }
  },
  {
    path: '/gestionar_producto_final',
    name: 'GestionarProductoFinal',
    component: GestionarProductoFinal,
    meta: { breadcrumb: 'Gestionar Producto Final', requiresAuth: true }
  },
  {
    path: '/gestionar_producto_envasado',
    name: 'GestionarProductoFinalEnvasado',
    component: GestionarProductoFinalEnvasado,
    meta: { breadcrumb: 'Gestionar Producto Final Envasado', requiresAuth: true }
  },
  {
    path: '/trazabilidad',
    name: 'TrazabilidadBuscador',
    component: TrazabilidadBuscador,
    meta: { breadcrumb: 'Trazabilidad', requiresAuth: true },
  },
  {
    path: '/exportar',
    name: 'GestionarExport',
    component: GestionarExport,
    meta: { breadcrumb: 'Exportar Datos', requiresAuth: true },
  },
  {
    path: '/analisis',
    name: 'AnalisisDashboard',
    component: AnalisisDashboard,
    meta: { breadcrumb: 'Análisis', requiresAuth: true },
  },
  {
    path: '/cumplimiento',
    name: 'cumplimiento',
    component: cumplimientoGestion,
    meta: { breadcrumb: 'Cumplimiento', requiresAuth: true },
    children: [
      {
        path: '/cumplimiento/alta',
        name: 'altaCumplimiento',
        component: altaCumplimiento,
        meta: { breadcrumb: 'Alta Cumplimiento' }
      },
      {
        path: '/cumplimiento/alta/:grupoId?',
        name: 'editarGrupo',
        component: altaCumplimiento,
        props: true,
        meta: { breadcrumb: 'Editar Grupo' }
      },
      {
        path: '/cumplimiento/listar',
        name: 'listarCumplimientos',
        component: ListarCumplimientos,
        meta: { breadcrumb: 'Listar Cumplimientos' }
      }
    ]
  },
  {
    path: '/plan_cultivo',
    name: 'planCultivo',
    component: planCultivoGestion,
    meta: { breadcrumb: 'Plan de Cultivo', requiresAuth: true },
    children: [
      {
        path: '/plan_cultivo/alta',
        name: 'altaPlanCultivo',
        component: altaPlanCultivo,
        meta: { breadcrumb: 'Alta Plan de Cultivo' }
      },
      {
        path: '/plan_cultivo/listar',
        name: 'listarPlanesCultivo',
        component: listarPlanesCultivo,
        meta: { breadcrumb: 'Listar Planes de Cultivo' }
      },


    ]
  },


  {
    path: '/estadisticas/proyecto',
    name: 'proyectoEstadistica',
    component: proyectoEstadistica,
    props: true,
    meta: { breadcrumb: 'EstadísticasProyecto', requiresAuth: true }
  },
  {
    path: '/personal',
    name: 'personal',
    component: PersonalGestion,
    meta: { breadcrumb: 'Personal', requiresAuth: true }
  },
  {
    path: '/usuarios-medicinales',
    name: 'UsuariosMedicinales',
    component: UsuariosMedicinales,
    meta: { breadcrumb: 'Usuarios Medicinales', requiresAuth: true }
  },
  {
    path: '/libreta-tareas',
    name: 'libretaTareas',
    component: LibretaTareas,
    meta: { breadcrumb: 'Libreta de Tareas', requiresAuth: true }
  },
  {
    path: '/flujo_produccion',
    name: 'FlujoProduccion',
    component: FlujoProduccion,
    meta: { breadcrumb: 'Flujo de Producción', requiresAuth: true }

  },
  {
    path: '/cultivos',
    name: 'CultivosWrapper',
    component: CultivosWrapper,
    meta: { breadcrumb: 'Cultivos', requiresAuth: true}
  },

  {
    path: '/pago',
    name: 'pago',
    component: MercadoPagoView
  },
  {
    path: '/pago-exitoso',
    name: 'pagoExitoso',
    component: PagoExitoso,
  },
  {
    path: '/pago-fallido',
    name: 'pagoFallido',
    component: PagoFallido,
  },
  {
    path: '/pago-pendiente',
    name: 'pagoPendiente',
    component: PagoPendiente,
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/bienvenida'
  }
  




];


const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})





// Protección de rutas

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = !!localStorage.getItem('token');



  if (requiresAuth && !isAuthenticated) {
    return next({ name: 'BienvenidaPublica' });
  }

  return next();
});







export default router
